import { useCallback, useEffect, useState } from "react";

// Client-side "auto-load-on-scroll" for lists whose full dataset is already in
// memory (needed for tab counts / grouping / client filters). Reveals `step`
// rows at a time; resets whenever `resetKey` changes.
export function useProgressiveList(resetKey, step = 50) {
  const [visibleCount, setVisibleCount] = useState(step);
  useEffect(() => { setVisibleCount(step); }, [resetKey, step]);
  const showMore = useCallback(() => setVisibleCount((c) => c + step), [step]);
  return { visibleCount, showMore };
}
